import {observer} from "mobx-react";
import {Component} from "preact";
import {resources} from "../resources";
import {Button} from "./controls/Button";
import {Dialog, DialogContent, DialogTitle} from "./controls/Dialog";
import {Spacer} from "./controls/Spacer";

interface AddLocationDialogProps {
	open: boolean;
	onClose: () => void;
	onUseDeviceLocation: () => void;
	onEnterLocationCode: () => void;
	deviceLocationPending: boolean;
}

export const AddLocationDialog = observer(
	class AddLocationDialog extends Component<AddLocationDialogProps> {
		render() {
			const {open, onClose, onUseDeviceLocation, onEnterLocationCode, deviceLocationPending} = this.props;
			return (
				<Dialog open={open} onBackdropClick={onClose}>
					<DialogContent>
						<DialogTitle>{resources.strings.DetermineLocation}</DialogTitle>

						<Button
							disabled={deviceLocationPending}
							pending={deviceLocationPending}
							onClick={onUseDeviceLocation}
							choice
						>
							{resources.strings.UseDeviceLocation}
						</Button>

						<Button disabled={deviceLocationPending} onClick={onEnterLocationCode} choice>
							{resources.strings.EnterLocationCode}
						</Button>

						<Spacer height={"10vh"} />

						<Button onClick={onClose}>{resources.strings.Cancel}</Button>
					</DialogContent>
				</Dialog>
			);
		}
	},
);
